import { getSessionId } from '@fs/zion-session'
import { Bleed, Card, Image, LabelTooltip, QuickGlanceOverlay, colors, useOverlay } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { NoticeDoNot, NoticeWarning } from '@fs/zion-icon/dist/cjs/icons'
import { useTranslation } from 'react-i18next'
import { getMessageAttachmentInfo } from '../../../../services/chatService'

export default function ImageAttachment({ attachment, setFetchingImages }) {
  const { t } = useTranslation()
  const overlay = useOverlay()
  const [attachmentInfo, setAttachmentInfo] = useState()

  useEffect(() => {
    const fetchMessageAttachmentInfo = async () => {
      setFetchingImages &&
        setFetchingImages((prevState) => {
          if (!prevState) {
            return [attachment.id]
          }
          prevState.push(attachment.id)
          return prevState
        })
      try {
        const response = await getMessageAttachmentInfo(attachment.id)
        setAttachmentInfo(response.data)
      } catch (err) {
        // continue
      }
      setFetchingImages &&
        setFetchingImages((prevState) => {
          const fetchingImagesCopy = [...prevState]
          const index = fetchingImagesCopy.indexOf(attachment.id)
          if (index !== -1) {
            fetchingImagesCopy.splice(index, 1)
          }
          return fetchingImagesCopy
        })
    }
    fetchMessageAttachmentInfo()
  }, [attachment.id, setFetchingImages])

  if (!attachmentInfo) {
    return null
  }

  return (
    <>
      {attachmentInfo.screeningState === 'APPROVED' && (
        <>
          <Card maxWidth="100px" onClick={overlay.handleClick}>
            <Bleed growY all>
              <Image src={`${attachmentInfo.thumbmobileUri}?sessionId=${getSessionId()}`} alt={attachment.filename} />
            </Bleed>
          </Card>
          <QuickGlanceOverlay maxWidth="500" {...overlay}>
            <Image
              src={`${attachmentInfo.thumbmobileUri}?sessionId=${getSessionId()}`}
              alt={attachment.filename}
              maxHeight="90vh"
            />
          </QuickGlanceOverlay>
        </>
      )}
      {attachmentInfo.screeningState === 'UNSCREENED' && (
        <LabelTooltip
          target={<NoticeWarning color={colors.yellow20} />}
          label={t('chat.attachment.imageUnscreened', 'Image is unscreened')}
        />
      )}
      {attachmentInfo.screeningState === 'RESTRICTED' && (
        <LabelTooltip
          target={<NoticeDoNot color={colors.red40} />}
          label={t('chat.attachment.imageRestricted', 'Image has been restricted')}
        />
      )}
    </>
  )
}
